import { render, staticRenderFns } from "./DocumentDashboard.vue?vue&type=template&id=19e7351e&scoped=true&"
import script from "./DocumentDashboard.vue?vue&type=script&lang=js&"
export * from "./DocumentDashboard.vue?vue&type=script&lang=js&"
import style0 from "./DocumentDashboard.vue?vue&type=style&index=0&id=19e7351e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e7351e",
  null
  
)

component.options.__file = "DocumentDashboard.vue"
export default component.exports